import styled from 'styled-components'

const white = '#FFF'
const grey = '#F2F2F2'
const lavander = '#F6F8FD'
const blue = '#50A7EE'
const shadow = '#50A7EEB2'

export const StyledMagazineCoverOuter = styled.div`
    background-color: ${grey};
    padding: 15px;
    margin: 0 auto;
    margin-bottom: 20px;
    @media only screen and (min-width: 1024px) {
        width: 80%;
    }
`

export const StyledInnerDiv = styled.div`
    padding: 15px;
    background-color: ${lavander};
    @media only screen and (min-width:1024px) {
        display: flex;
    }
    article {
        display: flex;
    }
`

export const StyledCoverImage = styled.div`
    width: 100%;
    margin: 0 auto;
    @media only screen and (max-width:1023px) {
        margin-bottom: 10px;
    }
    @media only screen and (min-width:1024px) {
        width: 70%;
        margin-right: 10px;
    }
    img {
        display: block;
        max-width: 100%;
    }
`

export const StyledDescriptionDiv = styled.div`
    text-align: center;
    p {
        margin: 0px;
        font-size: 24px;
        line-height: 1.4;
    }
    .percentage {
        font-size: 55px;
    }
`

export const StyledSubscribeButton = styled.a`
    display: block;
    width: 200px;
    height: 50px;
    margin: 20px auto 0;
    padding: 12px 0px;
    text-align: center;
    background: ${blue};
    color: ${white} !important;
    box-shadow: 0px 0px 14px 0px ${shadow};
`
